import React from "react";
import './styles.css';

const Blog = () =>
{
    return(
        <>
            <section>
            <h1 className="fw-bold m-5">
                Work in Progress !
            </h1>
            </section>
            
        </>
    )
}

export default Blog;